import { Component, OnInit } from "@angular/core";
import { ViewCell } from "ng2-smart-table";

@Component({
  template: `
  <nb-icon *ngIf="value.pack == 'eva'" [icon]="value.icon"></nb-icon><nb-icon *ngIf="value.pack == 'font-awesome'" [icon]="value.icon" pack="font-awesome"></nb-icon>
  `,
  styles: []


})
export class IconPropertyRenderComponent implements ViewCell, OnInit {
  value: string | number | any;

  rowData: any;
  visible: boolean;
  ngOnInit(): void {
    //this.visible = this.value.length > 0 && this.value[0] != '';

  }

}
